/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./UpdatePauseDialog.vue?vue&type=template&id=48789c84"
import script from "./UpdatePauseDialog.vue?vue&type=script&lang=js"
export * from "./UpdatePauseDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48789c84')) {
      api.createRecord('48789c84', component.options)
    } else {
      api.reload('48789c84', component.options)
    }
    module.hot.accept("./UpdatePauseDialog.vue?vue&type=template&id=48789c84", function () {
      api.rerender('48789c84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patients/UpdatePauseDialog.vue"
export default component.exports